import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fullStatus',
    standalone: false
})
export class FullStatusPipe implements PipeTransform {

    transform(str: string): string {
        if (str === 'O') {
            return 'Öppen';
        }
        else if (str === 'Å') {
            return 'Återbesök';
        }
        else if (str === 'A') {
            return 'Attest';
        }
        else if (str === 'F') {
            return 'Fakturerad i QUL';
        }
        else if (str === '*') {
            return 'Fakturerad i Agresso';
        }
        else if (str === 'P') {
            return 'Pågår';
        }
        else if (str === 'T') {
            return 'Tilldelad';
        }
        else if (str === 'U') {
            return 'Utförd';
        }
        else if (str === 'R') {
            return 'Ryckhantering';
        }
        else {
            return str;
        }

    }

}



